import React, { useState } from 'react';
import { Container, Grid } from '@mantine/core';
import { MantineReactTable } from 'mantine-react-table';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

export default function RolePermission() {

  const [activeRole, setActiveRole] = useState('admin');

  const getAdminTableData = () => {
    return [
      {
        role: 'Admin Page',
        role_id: 'Admin Options',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Department',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Locations',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Roles',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Status',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Application Preferences',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),
      },
      {
        role: 'Admin Pages',
        role_id: 'Role Permissions',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'External Users',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Approval Types',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Approval Type',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Employees',
        role_name: (
          <div>
            <div className='d-flex check-box2'>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">List/View</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">All</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My</label>
              </div>
            </div>

            <div className='box2'>

              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Add</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Edit</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Delete</label>
              </div>
            </div>

          </div>
        ),
      },
      {
        role: 'Admin Pages',
        role_id: 'Email Notification Preferences',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Import Export',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Account Disable',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Manage Terminology',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Time Off Status',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Employee Type',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Holiday Types',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Holiday Type Detail',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Holidays Select',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Feature Management',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Time Off Types',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Page',
        role_id: 'Time Off Policies Detail',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Admin Pages',
        role_id: 'Time Off Policies',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Delete</label>
            </div>
          </div>
        ),

      },
    ];
  };

  const getUserPageTableData = () => {
    return [
      {
        role: 'User Pages',
        role_id: 'My Dashboard',
        role_name: (
          <div className="d-flex check-box2 ">
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text"  >All</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text" >My</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text"  >My Projects</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text" >My Teams</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">My Sub-Ordinates</label>
            </div>
          </div>

        ),
      },
      {
        role: 'User Pages',
        role_id: 'Audit Trail',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
          </div>
        ),

      },
      {
        role: 'User Pages',
        role_id: 'My Profile',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
          </div>
        ),

      },
      {
        role: 'User Pages',
        role_id: 'My Email Preferences',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
          </div>
        ),

      },
      {
        role: 'User Pages',
        role_id: 'My Time Off',
        role_name: (
          <div>
            <div className='d-flex check-box2'>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">List/View</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">All</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Projects</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Teams</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Sub-Ordinates</label>
              </div>
            </div>

            <div className='box2'>

              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Add</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Edit</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Delete</label>
              </div>
            </div>

          </div>
        ),
      },
      {
        role: 'User Pages',
        role_id: 'My Time Off Request',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Add</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),

      },
    ];
  };

  const getUserReportTableData = () => {
    return [
      {
        role: 'Users Reports',
        role_id: 'My Reports',
        role_name: (
          <div>
            <div className='d-flex check-box2'>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">List/View</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">All</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Projects</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Teams</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Sub-Ordinates</label>
              </div>
            </div>
            <div className='d-flex check-box2'>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Add</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">All</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Projects</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Teams</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Sub-Ordinates</label>
              </div>
            </div>
            <div className='d-flex check-box2'>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Edit</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">All</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Projects</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Teams</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Sub-Ordinates</label>
              </div>
            </div>
            <div className='d-flex check-box2'>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">Delete</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">All</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Projects</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Teams</label>
              </div>
              <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text">My Sub-Ordinates</label>
              </div>
            </div>
          </div>

        ),
      },
      {
        role: 'Users Reports',
        role_id: 'Report Permission',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),

      },
      {
        role: 'Users Report',
        role_id: 'Report Design',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
          </div>
        ),

      },

    ];
  };
  const getApprovalTableData = () => {
    return [
      {
        role: 'User Pages',
        role_id: 'My Time Off Request',
        role_name: (
          <div className='box2'>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">List/View</label>
            </div>
            <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text">Edit</label>
            </div>
          </div>
        ),

      },

    ];
  };

  const UpdateBtn = () => {
    Swal.fire({
      title: 'Update Confirmation',
      text: 'Are you sure you want to update?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!',
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle the update logic here
        Swal.fire('Updated!', 'Your data has been updated.', 'success');
      }
    });
    // Your SaveButton logic her
  };


  const tableDataAdmin = activeRole === 'admin' ? getAdminTableData() : [];
  const tableDataUserPage = activeRole === 'user_pages' ? getUserPageTableData() : [];
  const tableDataUserReport = activeRole === 'user_report' ? getUserReportTableData() : [];
  const tableDataApproval = activeRole === 'approvals' ? getApprovalTableData() : [];


  const switchTable = [...tableDataAdmin, ...tableDataUserPage, ...tableDataUserReport, ...tableDataApproval];
  const tableColumns = [
    {
      accessorKey: 'role',
      header: 'Category',

    },
    {
      accessorKey: 'role_id',
      header: 'Page Description',
    },
    {
      accessorKey: 'role_name',
      header: 'Permissions',
      style: { minWidth: '500px' },
    }
  ];
  const handleRoleButtonClick = (role) => {
    setActiveRole(role);

  };

  return (
    <Container fluid >
      <Grid>
        <Grid.Col xs={12}>
          <div>
            <span className='breachCrumb'>
              <Link to="/user-setting-dashboard">Setting</Link> /{' '}
              <Link to="/user-setting-dashboard/rolepermission">Role Permission</Link>
            </span>
          </div>
          <div className="headerSection">
            <h5>Role Permission</h5>
          </div>
          <div className='rolebuttonSection'>
            <button
              className={`rolebtnbutton ${activeRole === 'admin' ? 'active' : ''}`} onClick={() => handleRoleButtonClick('admin')}>
              ADMIN PAGES
            </button>

            <button
              className={`rolebtnbutton ${activeRole === 'user_pages' ? 'active' : ''}`} onClick={() => handleRoleButtonClick('user_pages')}>
              USER PAGE
            </button>
            <button
              className={`rolebtnbutton ${activeRole === 'user_report' ? 'active' : ''}`} onClick={() => handleRoleButtonClick('user_report')}>
              USERS REPORT
            </button>
            <button
              className={`rolebtnbutton ${activeRole === 'approvals' ? 'active' : ''}`} onClick={() => handleRoleButtonClick('approvals')}>
              APPROVALS
            </button>
          </div>
          <div className='lastbuttonSection'>
            <button className="lastbutton" onClick={UpdateBtn}>
              Update</button>
          </div>
        </Grid.Col>
        <Grid.Col xs={12}>
          <div className="tab">
            <MantineReactTable
              columns={tableColumns}
              data={switchTable}
              enableFullScreenToggle={false}
              enableColumnOrdering
              enableRowNumbers
              responsiveLayout={{ breakpoint: 'sm' }}

            />
          </div>
        </Grid.Col>
      </Grid>
      <div className='lastbuttonSection'>
        <button className="lastbutton" onClick={UpdateBtn}>
          Update</button>
      </div>
    </Container>


  );
}





